// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import {
    useLocation,
} from 'react-router-dom'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
    reduxModalSetNavbarOpenIdSite,
} from 'data'

// pages
import {
    EditBlockSite,
} from 'pages'

// serializers
import {
    CustomCSSProperties,
    MainStyleSerializer,
    PortfolioPageContentListSiteSerializer,
} from 'serializers/site'

// services
import {
    getStylesNew,
} from 'services'

// props
type TemplateBlock791SiteProps = {
    blockId: string
    isEditHovered: boolean
    isInComponent?: boolean
    mainParentId?: number
    object: PortfolioPageContentListSiteSerializer
    parentArray?: number[]
    parentNavbarId?: number
    parentStyles?: any
    styles: MainStyleSerializer
    stylesEdit: MainStyleSerializer | undefined
}

// main
export const TemplateBlock791Site: React.FC<TemplateBlock791SiteProps> = React.memo(({
    blockId,
    isEditHovered,
    isInComponent,
    mainParentId,
    object,
    parentArray,
    parentNavbarId,
    parentStyles,
    styles,
    stylesEdit,
}) => {

    const dispatch = useDispatch()
    const location = useLocation()
    const reduxFormSitenavigationMode = useSelector((state: defaultReduxState) => state.reduxFormSite.navigationMode)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const deviceType = reduxModalSite.deviceType

    const [stylesNew, setStylesNew] = useState<{
        borderRadius: string | number | undefined,
        burgerType: string | undefined,
        color: string | undefined,
        height: string | number | undefined,
        styles: CustomCSSProperties | undefined,
        width: string | number | undefined,
    } | undefined>(applyStyles())

    useEffect(() => {
        if (reduxFormSitenavigationMode === 'edit') {
            return
        }
        dispatch(reduxModalSetNavbarOpenIdSite(undefined))
    }, [
        location,
    ])

    useEffect(() => {
        setStylesNew(applyStyles())
    }, [
        object.id,
        reduxModalSite,
        reduxModalSite.navbarOpenId,
        styles,
        stylesEdit,
    ])

    function applyStyles() {
        try {
            const aStyles = getStylesNew(reduxModalSite, styles, stylesEdit)
            return {
                borderRadius: aStyles?.borderRadius,
                burgerType: aStyles?.burgerType || 'squeeze',
                color: (reduxModalSite.navbarOpenId === parentNavbarId) ? (aStyles?.activeColor || aStyles?.color) : aStyles?.color,
                height: aStyles?.height,
                styles: {
                    background: aStyles?.background,
                    display: aStyles?.display,
                    padding: aStyles?.padding,
                },
                width: aStyles?.width,
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock791Site',
                'applyStyles',
            ))
        }
    }

    return (
        <button
            id={blockId}
            className={`template-block-791 hamburger hamburger--${stylesNew?.burgerType} bs-hamburger${(reduxModalSite.navbarOpenId && reduxModalSite.navbarOpenId === parentNavbarId) ? ' is-active' : ''}${isEditHovered ? ' is-edit-hovered' : ''} ${deviceType}`}
            onClick={() => dispatch(reduxModalSetNavbarOpenIdSite(parentNavbarId))}
            style={stylesNew?.styles}
            type='button'
        >
            <span
                className={`hamburger-box bs-hamburger-box ${deviceType}`}
                style={{
                    width: stylesNew?.width,
                }}
            >
                <span
                    className={`hamburger-inner bs-hamburger-inner ${deviceType}`}
                    style={{
                        background: stylesNew?.color,
                        borderRadius: stylesNew?.borderRadius,
                        height: stylesNew?.height,
                        width: stylesNew?.width,
                    }}
                />
            </span>
            <EditBlockSite
                isInComponent={isInComponent}
                mainParentId={mainParentId || object.id!}
                object={object}
                parentArray={parentArray}
                parentStyles={parentStyles}
            />
        </button>
    )
})
